module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "nonindent01"
  }, [_vm._v("Give me your tired, your poor,")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent22"
  }, [_vm._v("Your huddled masses yearning to breathe free,")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent22"
  }, [_vm._v("The wretched refuse of your teeming shore.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent22"
  }, [_vm._v("Send those, the homeless, tempest-tost to me.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent22"
  }, [_vm._v("I lift my lamp beside the golden door.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INSCRIPTION BY")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MMA")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AZARUS")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Statue of Liberty, New York Harbor")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent01"
  }, [_vm._v("Yet there comes a time for forgetting,")]), _vm._v(" "), _c('p', {
    staticClass: "indent11"
  }, [_vm._v("for who could live and not forget?")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent22"
  }, [_vm._v("Now and then, however, there must also")]), _vm._v(" "), _c('p', {
    staticClass: "indent11"
  }, [_vm._v("be one who remembers.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LBRECHT")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OES,")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Das Brandopfer")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4b8606","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm01.vue
// module id = 75
// module chunks = 0